//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/TaggedObject.js";
import "../no/OMAttribute.js";
let d=[[[0,"Superclass",0,"OMClass",0]],[[["count"],"GetAttributes",{R_:{attributes:"OMAttribute[]"}},0,0],[["attribute"],"IsDefiningClassFor",{R_:{result:''}},1,0],[["count"],"GetAllAttributeInfo",{R_:{info:""}},0,0],[[],"GetObjectName",{R_:{name:''}},0,0],[["other"],"CompareWith",{R_:{res:''}},1,0]],[]];
SPLM.OMClass = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.OMClass";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;